import React, { Component } from 'react';
import BolOutput from './bolOutput';
import AdCvdOutput from './adCvdOutput';
import CrOutput from './crOutput';
import EsOutput from './esOutput';
import ResponseSummary from './responseSummary';
import HtsOutput from './htsOutput';
import MidEditableOutput from './midEditableOutput';
import ShortButton from "./ShortButton";
import { Icon } from "semantic-ui-react";
//import  Images from '../../config/images'
import { qryFuncPlaceholderIcon } from './images'
import ReactToPrint from 'react-to-print';
import { toast } from "../../commonComponents/Toast";
import _ from 'lodash'

export default class ResultOutput extends Component {  
    constructor(props) {
        super(props)
    }    
    
    render(){
        let qryType = this.props.qryType || _.get(this.props, "qryInput.qryType", "");
        if (this.props.launchFrom === 'MF_FORM' && !qryType) {
            qryType = 'MID';
        }
        const responseParams = _.get(this.props, "qryOutput.responseParams", {});
        // Empty response after Customs Queries close/reset → outputPlaceholder
        // MID manufacturer modal still shows MidEditableOutput (OR / Add Manually) with empty results
        const isMidManualForm = this.props.launchFrom === 'MF_FORM';
        const showResults = isMidManualForm || (!!qryType && !_.isEmpty(responseParams));
        let returnedModifiedDate = _.get(responseParams, "lastModified", "");
        if(!returnedModifiedDate){
            returnedModifiedDate = _.get(responseParams, "updateTime", "");
        }

        const placeholder = (
             <table style={{margin:'auto'}}>
            <tbody><tr><td>
                <div className='outputPlaceholder'>
                    <div className='qryFuncPlaceholderIcon'>
                        <img src={qryFuncPlaceholderIcon} />
                    </div>
                    <div className='defaultText'>{
                        this.props.hideLeftPanel ? 'Please Wait...' :
                        this.props.launchFrom === 'MF_FORM' ? `Search with keyword or type in mid query input and click Run button or click Add Manually to add new manufacturer.` :
                        `Type input(s) from a query type from the left then click to run results.`}
                    </div>
                </div>
             </td></tr></tbody></table>
        );

    return (<React.Fragment>
        {
            showResults &&
            <span style={{color:'#777',fontSize:'.8rem'}}>
                {
                    returnedModifiedDate && <React.Fragment>Last Execution: {returnedModifiedDate} </React.Fragment>
                }
                <ReactToPrint
                    trigger={() => {
                        // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                        // to the root node of the returned component as it will be overwritten.
                        return <ShortButton style={{backgroundColor: "teal", color:"#fff", float:'right',marginTop:'-24px'}} id='printQryFunc'><Icon name="print" />Print</ShortButton>;
                    }}
                    content={() => this.props.componentRef}
                    onPrintError = {()=> {
                        toast.warning("There is nothing to print.");
                    }}
                />
            </span>
        }
        <div id='resultTbl'><div id='resultOutput' className={`resultOutput force-scrollbar ${this.props.launchFrom}_lf ${this.props.saveTo !== undefined ? this.props.saveTo : ""}`}>
            { !showResults ? placeholder :
             qryType === 'ADCVD' ? (<AdCvdOutput {...this.props}/>) :
             qryType === 'BOL' ? (<BolOutput {...this.props}/>) : 
             qryType === 'CR'  ? (<CrOutput {...this.props}/>) : 
             qryType === 'MID' && this.props.launchFrom !== 'MF_FORM' ? (<CrOutput {...this.props}/>) : 
             qryType === 'MID' && this.props.launchFrom === 'MF_FORM' ? (<MidEditableOutput userType={this.props.userType} qryType={`MID`} set_MF_Form_Data={this.props.set_MF_Form_Data} {...this.props}/>) : 
             qryType === 'IB'  ? (<CrOutput {...this.props}/>) : 
             qryType === 'HTS'  ? (<HtsOutput {...this.props}/>) :
             qryType === 'ES'  ? (<EsOutput enableDisablePsc={this.props.enableDisablePsc} {...this.props}/>) : 
             qryType === 'CRITERIAQUERYQQ'  ? (<EsOutput enableDisablePsc={this.props.enableDisablePsc} {...this.props}/>) : 
             qryType === 'RESPONSE_SUMMARY'  ? (<ResponseSummary enableDisablePsc={this.props.enableDisablePsc} {...this.props}/>) : 
             placeholder
            }
        </div></div>
        </React.Fragment>)
    }
}
